<template>
    <Dialog
        :open="isOpen"
        role="alertdialog"
        class="alert-dialog text-gray-600 fixed inset-0 z-[100000] flex items-center justify-center bg-black bg-opacity-50 h-screen w-screen"
    >
        <DialogPanel class="bg-white rounded-xl p-5 w-full max-w-md mx-auto shadow-lg flex flex-col">
            <DialogTitle class="text-xl font-semibold mb-4" v-if="dialogOptions?.title">
                {{ dialogOptions.title }}
            </DialogTitle>
            <DialogDescription class="mb-4" v-if="dialogOptions?.message">
                {{ dialogOptions.message }}
            </DialogDescription>
            <div class="flex justify-end gap-3">
                <button
                    v-if="dialogOptions?.closeMessage"
                    @click="onClose"
                    type="button"
                    class="px-4 py-2.5 text-sm font-medium border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors"
                >
                    {{ dialogOptions.closeMessage }}
                </button>
                <button
                    v-if="dialogOptions?.confirmMessage"
                    @click="onConfirm"
                    type="button"
                    class="px-4 py-2.5 text-sm font-medium bg-primary-500 text-white rounded-xl hover:bg-primary-600 transition-colors"
                >
                    {{ dialogOptions.confirmMessage }}
                </button>
            </div>
        </DialogPanel>
    </Dialog>
</template>

<script lang="ts" setup>
import { Dialog, DialogPanel, DialogTitle, DialogDescription } from '@headlessui/vue';
const { isOpen, dialogOptions, onConfirm, onClose } = useDialog();
</script>
